<template lang="pug">
    .col-md-6.col-sm-6.col-xs-12.box-parent-lesson
      .box-item-lesson
        router-link.grade-format(:to="{ path: '/' + url + '/lesson/' + lesson.grade_id}" target= '_blank') {{lesson.grade_name}}
        a(:href="getLinkDetail(lesson)" target= '_blank')
          img(:src="lesson.banner[0]" v-if="lesson.banner && lesson.banner !== null && lesson.banner.length > 0")
          img(src="../../../assets/Obee_Logo_140@2x.png" v-else)
        .overlay
          a(:href="getLinkDetail(lesson)" target= '_blank')
        .item-title
          a(:href="getLinkDetail(lesson)" target= '_blank')
            span {{lesson.name}}
      .item-social
        span
          i.like.fa(@click="likeLesson(lesson.id)" v-if="!liked")
            img(src="../../../assets/images/home/ic_like_outline.svg")
            | {{ numberWithCommas(lesson.count_like) }}
          i.like.fa(@click="unLikeLesson(lesson.id)" v-else)
            img(src="../../../assets/images/home/ic_like.svg")
            | {{ numberWithCommas(lesson.count_like) }}
        span
          i.fa
            img(src="../../../assets/images/home/ic_comment.svg")
            | {{ numberWithCommas(lesson.count_comment) }}
        span
          i.fa
            img(src="../../../assets/images/home/ic_share.svg")
            | {{ numberWithCommas(lesson.count_share) }}
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../../Model/graphqlfront'
export default {
  props: {
    lesson: Object,
    obj_id: Number,
    url: String
  },
  data() {
    return {
      object_id: this.obj_id,
      isSucess: false,
      liked: false
    }
  },
  methods: {
    getLinkDetail(item) {
      var link = window.location.origin + '/' + this.$router.resolve({name: 'landing'}).href + this.url
      return link + '/lesson/detail/' + item.id
    },
    likeLesson(id) {
      this.$apollo.mutate({
        mutation: gql(graphql.LIKE_LESSONS_HOME),
        variables: {
          object_id: id,
          user_id: this.$store.getters.user
        },
        update: (store, { data: { insert_likes_lesson } }) => {
          if (insert_likes_lesson.affected_rows) {
            this.liked = true
            this.lesson.count_like++
          }
          this.isSucess = false
        }
      })
    },
    unLikeLesson(id) {
      this.$apollo.mutate({
        mutation: gql(graphql.UNLIKE_LESSONS_HOME),
        variables: {
          object_id: id,
          user_id: this.$store.getters.user
        },
        update: (store, { data: { delete_likes_lesson } }) => {
          if (delete_likes_lesson.affected_rows) {
            this.liked = false
            this.lesson.count_like--
          }
          this.isSucess = false
        }
      })
    },
    isMobile() {
      if (window.innerWidth < 991) return true
      return false
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    }
  },
  async mounted () {
    this.liked = false
    const {data} = await this.$apollo.query({
      query: gql(graphql.GET_LESSONS_LIKE_HOME),
      fetchPolicy: 'no-cache',
      variables: {
        object_id: this.object_id,
        user_id: this.$store.getters.user
      }})
    this.liked = data.likes_lesson.length
  },
  apollo: {
  }
}
</script>
<style lang="scss">
</style>




// WEBPACK FOOTER //
// Item.vue?1d8fd740